export enum CampaignsActionTypes {
  FETCH_CAMPAIGNS_LIST_SUCCESS = "FETCH_CAMPAIGNS_LIST_SUCCESS",
  FETCH_CAMPAIGNS_LIST_ERROR = "FETCH_CAMPAIGNS_LIST_ERROR",
  FETCH_CAMPAIGNS_LIST = "FETCH_CAMPAIGNS_LIST",
}

interface FetchCampaignsList {
  type: CampaignsActionTypes.FETCH_CAMPAIGNS_LIST
}

interface FetchCampaignsListSuccess {
  type: CampaignsActionTypes.FETCH_CAMPAIGNS_LIST_SUCCESS
  payload: ICampaignForSelect[]
}

interface FetchCampaignsListError {
  type: CampaignsActionTypes.FETCH_CAMPAIGNS_LIST_ERROR
  payload: string
}

export type CampaignsAction =
  | FetchCampaignsList
  | FetchCampaignsListSuccess
  | FetchCampaignsListError

export interface CampaignsState {
  campaigns: ICampaignForSelect[]
  loaded: boolean
  error: string | null
}

export interface ICampaignForSelect {
  campaignId: string
  campaignName: string
}
